<template>
  <DpplHeaderFooterContent class="editor-layout-container">
    <template #header>
      <div class="full-width-header">
        <slot name="full-width-header" />
      </div>
    </template>

    <DpplHeaderFooterContent
      v-if="sideBySideView"
      class="w-100"
    >
      <div class="w-50">
        <slot name="side-revision" />
      </div>
      <div class="w-50">
        <DpplHeaderFooterContent>
          <template #footer>
            <div class="content-footer">
              <slot name="content-footer" />
            </div>
          </template>
          <slot name="content" />
        </DpplHeaderFooterContent>
      </div>
    </DpplHeaderFooterContent>

    <DpplHeaderFooterContent
      v-if="!sideBySideView"
      class="editor-layout mx-auto w-100"
    >
      <template #header>
        <slot name="header" />
      </template>

      <div class="w-25">
        <slot name="left" />
      </div>

      <DpplHeaderFooterContent class="w-50 h-100 overflow-x-hidden">
        <div class="w-100 content">
          <slot name="content" />
        </div>

        <template #footer>
          <div class="content-footer">
            <slot name="content-footer" />
          </div>
        </template>
      </DpplHeaderFooterContent>

      <div class="w-25">
        <slot name="right" />
      </div>
    </DpplHeaderFooterContent>
  </DpplHeaderFooterContent>
</template>

<script setup>
import DpplHeaderFooterContent from '@ui/components/general/DpplHeaderFooterContent/DpplHeaderFooterContent.vue';

defineProps({
  sideBySideView: {
    type: [Boolean, String],
    default: false,
  },
});
</script>

<style scoped lang="less">
.editor-layout {
  max-width: 1800px;
}

.full-width-header {
  border-bottom: 1px solid @stroke-default;
}

.content-footer {
  border: 1px solid @stroke-default;
}

.content {
  border-left: 1px solid @stroke-default;
  border-right: 1px solid @stroke-default;
}
</style>
